import Vue from 'vue';
import { mapGetters } from 'vuex';
import dropsLoader from '@/mixins/components/drops-loader';
import SiteMap from './site-map';
import Theme from './theme';
import Meta from './meta';
import Fonts from './fonts';
import Cache from './cache';

export default Vue.component('global-options', {
  template: require('./template.html'),
  name: 'global-options',
  computed: {
    ...mapGetters(['editorLoader']),
  },
  components: {
    dropsLoader,
    SiteMap,
    Theme,
    Meta,
    Fonts,
    Cache,
  },
  data() {
    return {
      loading: false,
      updateInitial: false,
    };
  },
  props: ['modal'],
  watch: {
    modal(o) {
      this.$store.dispatch('setGlobalOpenModal', o);
    },
  },
  methods: {
    setInitial(v) {
      this.updateInitial = v;
      setTimeout(() => {
        this.updateInitial = false;
      }, 500);
    },
    setLoading(v) {
      this.loading = v;
    },
    toggleModal() {
      this.$emit('toggle-modal');
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/global-options/index.js